import React from 'react'
import Common from '../../utils/common';
import Configuration from '../../config';
import Pagination from "react-js-pagination";
import $ from "jquery"

export default class List extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            items: [],
            category: null,
            relations: [],
            build: '',
            activePage: 1
        }
    }
    componentDidMount() {
        this.setState({ activePage: 1 });
    }
    handlePageChange(pageNumber) {
        Common.activePage = pageNumber;
        this.setState({ activePage: pageNumber });

    }
    render() {

        var paramId = this.props.match.params.id;

        var param = {};
        param['paramId'] = paramId;

        this.state.build = Common.getPage('contact', param);

        return (
            <div dangerouslySetInnerHTML={{ __html: this.state.build }}>
            </div>
        )

    }

}

